import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  ApiVisa,
  BaseApiTemplateService,
  BasicApiResponseModel,
  Pagination,
  PagingResponseModel,
} from "../../shared";
import { Core2Config } from "../../shared";
import { Observable } from "rxjs";
import { EntityOutstandingDocumentDtoModel } from "../../../data-transfer-objects";

@Injectable({ providedIn: "root" })
export class EntityOutstandingDocumentService extends BaseApiTemplateService<EntityOutstandingDocumentDtoModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "entity-ar-ap-report/outstanding-documents";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "entity-ar-ap-report/outstanding-documents";
    this.httpClient = http;
  }

  public getDocumentsByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any
  ): Observable<PagingResponseModel<any>> {
    // console.log('get by criteria bsae-api');
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = url + "/?" + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}
